

export enum DiagramItem {
    Numl,
    Enum,
    View
}